import Command from "components/DesignSystem/Command/Command";
import { Button } from "components/DesignSystem/Button/Button";
import { ArrowLeft } from "components/icons/ArrowLeft";
import { BrowserWindow } from "components/icons/BrowserWindow";
import { ADMIN_QUICK_NAV_PAGES } from "constants/crmPages";
import { GroupResponse } from "types/Models/groups";
import { getCrmPageLink } from "util/getCrmPageLink";

type CompanyPagesProps = {
  company: GroupResponse;
  onNavigate: (to: string) => void;
  onLinkClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onBack: () => void;
};

export const CompanyPages = ({
  company,
  onNavigate,
  onLinkClick,
  onBack,
}: CompanyPagesProps) => (
  <>
    <div className="t-border-0 t-border-b t-border-solid t-border-neutral-0 t-px-4 t-py-2">
      <Button
        type="button"
        customType="link_neutral"
        size="small"
        leftIcon={<ArrowLeft size="14" />}
        onClick={onBack}
      >
        {company.name}
      </Button>
    </div>
    <Command.List className="t-h-[30rem]">
      <Command.Empty>No pages found</Command.Empty>
      {ADMIN_QUICK_NAV_PAGES.map((page) => (
        <Command.LinkItem
          key={page.name}
          value={page.name}
          to={getCrmPageLink(page, company.uuid)}
          onNavigate={onNavigate}
          onLinkClick={onLinkClick}
          icon={<BrowserWindow />}
        >
          {page.name}
        </Command.LinkItem>
      ))}
    </Command.List>
  </>
);
